'use strict';
import {DOM} from "./DOM.js";
import {Modals} from "./components/Modals.js";
import {Datatables} from "../components/Datatables.js";
export class Ajax {
	#admin_ajax;
	#fundraiserDatatable;
	constructor() {
		this.#admin_ajax = admin_ajax[0];

		if(window.LCE){
			LCE?.hooks?.editor && LCE.hooks.editor.addAction('datatable_initialized_levcharity-team-campaigns-users-table', 'editor', (datatable) => {
				this.#fundraiserDatatable = datatable;
			})
		}

	}

	#isSalesforceLogStatusAction(action) {
		return [
			'change_salesforce_warning_status',
			'change_salesforce_error_status',
		].includes(action);
	}

	#reloadSalesforceLogTable(action) {
		const tableID = {
			change_salesforce_warning_status: 'levcharity-salesforce-warning-table',
			change_salesforce_error_status: 'levcharity-salesforce-error-table',
		}[action];

		const instance = Datatables.datatableInstances?.[tableID];
		if (instance?.ajax) {
			instance.ajax.reload(null, false);
		}
	}

	handlers() {
		this.changeElementStatus('.select_reporting_detailed_action', 'toggle_donation_visibility');
		this.changeElementStatus('.select_reporting_detailed_action', 'change_order_status', true);
		this.changeElementStatus('.select_reporting_recurrence_action', 'change_subscription_status', true);
		this.changeElementStatus('.select_fundraising_campaign_donors_action','toggle_donation_visibility', true);
		this.changeElementStatus('.select_fundraising_campaign_donors_action','change_order_status', true);
		this.changeElementStatus('.select_p2p_campaign_donors_action','toggle_donation_visibility', true);
		this.changeElementStatus('.select_p2p_campaign_donors_action','change_order_status', true);
		this.changeElementStatus('.select_p2p_campaign_action','change_p2p_campaign_status', true);
		this.changeElementStatus('.select_email_action','change_email_status');
		this.changeElementStatus('.select_email_action','delete_levcharity_email', true);
		this.changeElementStatus('.select_confirmation_action','change_confirmation_status');
		this.changeElementStatus('.select_confirmation_action','delete_levcharity_confirmation', true);
		this.changeElementStatus('.select_offline_action','change_order_status', true);
		this.changeElementStatus('.select_participants_action','change_team_member_and_participant_campaign_status', true);
		this.changeElementStatus('.select_team_members_action','change_team_member_and_participant_campaign_status', true);
		this.changeElementStatus('.select_member_of_the_team_action','levcharity_user_approval_to_team', true);
		this.changeElementStatus('.select_ecard_action','change_ecard_status', true);
		this.changeElementStatus('.select_salesforce_warning_log_action', 'change_salesforce_warning_status');
		this.changeElementStatus('.select_salesforce_error_log_action', 'change_salesforce_error_status');
		this.changeElementStatus('.select_membership_action', 'change_membership_status');
		this.changeElementStatus('.select_form_product_order_action', 'change_order_status', true);
		this.changeElementStatus('.duplicate_record', 'levcharity_duplicate_record', true);
		this.changeElementStatus('.select_coupon_action', 'change_coupon_status',
			false
		);
		this.sendEmailNotification('.select_offline_action', 'send_email_action', true);

		// Contact donations actions
		this.changeElementStatus('.select_contact_donation_action', 'levcharity_contact_donation_actions', true);

		//Raisers Edge Funds
		this.changeElementStatus('.select_raisers_edge_funds_action', 'change_raisers_edge_funds_status');

		//Receipts
		this.changeElementStatus('.select_receipt_action', 'change_receipts_status');
		this.changeElementStatus('.select_receipt_action', 'delete_receipts', true);

		this.changeElementStatus('.select_tribute_card_action', 'change_tribute_card_status');
		this.changeElementStatus('.select_tribute_card_action', 'delete_tribute_card', true);

		this.triggerAction('.select_participants_action', 'open_commitments_modal');
		this.triggerAction('.select_team_campaign_action', 'archive_team_campaign');
	}



	sendEmailNotification(elementClass, action, confirmation = false, type = 'change') {
		document.addEventListener(type, (event) => {
			if (event.target.matches(elementClass)) {
				const xhr = new XMLHttpRequest();

				const url = this.#admin_ajax;
				const id = event.target.selectedOptions[0].dataset.id;

				const value = event.target.value;
				const nonce = event.target.selectedOptions[0].dataset.token;
				let proceed = false;
				let confirmMessage = '';

				if ('send-email' === value) {
					proceed = true;
					const params = new URLSearchParams();
					params.append('action', action);
					params.append('id', id);
					params.append('nonce', nonce);
					xhr.open('POST', url, true);
					xhr.setRequestHeader(
						'Content-type',
						'application/x-www-form-urlencoded'
					);
					xhr.onreadystatechange = () => {
						if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
							alert('Email sent successfully');
						}
					};
					xhr.send(params);
				}
			}
		});
	}


	changeElementStatus(elementClass, action, confirmation = false, type = 'change') {
		document.addEventListener(type, async ( event ) => {
			if ( event.target.matches(elementClass)) {
				const url = this.#admin_ajax;
				const id = event.target.selectedOptions[0].dataset.id;
				const title = event.target.selectedOptions[0].dataset.title ?? '';
				const teamId = event.target.selectedOptions[0].dataset.teamid ?? '';
				const captainId = event.target.selectedOptions[0].dataset.captainid ?? '';
				const value = event.target.value;
				const nonce = event.target.selectedOptions[0].dataset.token;
				const participantId = event.target.selectedOptions[0].dataset.participantId ?? '';
				const campaignId = event.target.selectedOptions[0].dataset.campaignId ?? '';
			let proceed = false;
			let confirmMessage = '';
			const params = new URLSearchParams();
			params.append('action', action);
			if(action === 'toggle_donation_visibility' && value === 'cancel-order') return;
			if(action === 'levcharity_duplicate_record' && (value === 'approve-campaign' || value === 'disapprove-campaign')) return;

			if(action === 'levcharity_duplicate_record' && value !== 'duplicate') return;

			// For contact donation actions, skip if not the right action type
			if(action === 'levcharity_contact_donation_actions' && value !== 'generate-receipt' && value !== 'send-email') return;

				if (id) {
					params.append('id', id);
				}

				if (nonce) {
					params.append('nonce', nonce);
				}

				if ('cancel-order' === value) {
					proceed = true;
					params.append('status', 'cancelled');
					// translators: %s will be replaced by order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to cancel the order %s. Are you sure?', 'levcharity'), id);
				}

				if ('complete-order' === value) {
					proceed = true;
					params.append('status', 'completed');
					// translators: %s will be replaced by order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change the status of the order %s to completed. Are you sure?', 'levcharity'), id);
				}

				if ('approve-order' === value) {
					proceed = true;
					params.append('status', 'pending');
					// translators: %s will be replaced by order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change the status of the order %s to pending. Are you sure?', 'levcharity'), id);
				}

				if ('disapprove-order' === value) {
					proceed = true;
					params.append('status', 'disapproved');
					// translators: %s will be replaced by order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change the status of the order %s to disapproved. Are you sure?', 'levcharity'), id);
				}

				if ( 'disable-coupon' === value ) {
					proceed = true;
					params.append( 'status', 'draft' );
				}

				if ( 'activate-coupon' === value ) {
					proceed = true;
					params.append( 'status', 'publish' );
				}

				if ('activate-subscription' === value) {
					proceed = true;
					params.append('status', 'active');
					// translators: %s will be replaced by subscription id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to activate the subscription %s. Are you sure?', 'levcharity'), id);
				}

				if ('pause-subscription' === value) {
					proceed = true;
					params.append('status', 'on-hold');
					// translators: %s will be replaced by subscription id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to pause the subscription %s. Are you sure?', 'levcharity'), id);
				}

			if ('cancel-subscription' === value) {
				proceed = true;
				params.append('status', 'cancelled');
				// translators: %s will be replaced by subscription id.
				confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to cancel the subscription %s. Are you sure?', 'levcharity'), id);
			}

			if ('generate-receipt' === value) {
				proceed = true;
				const orderId = event.target.selectedOptions[0].dataset.orderId;
				params.append('action', 'levcharity_generate_receipt_ajax');
				params.append('order_id', orderId);
				// translators: %s will be replaced by order id.
				confirmMessage = wp.i18n.sprintf(wp.i18n.__('Generate receipt for order #%s?', 'levcharity'), orderId);
			}

			if ('send-email' === value) {
				proceed = true;
				const orderId = event.target.selectedOptions[0].dataset.orderId;
				const donorEmail = event.target.selectedOptions[0].dataset.donorEmail;
				params.append('action', 'levcharity_send_email_to_donor_ajax');
				params.append('order_id', orderId);
				params.append('donor_email', donorEmail);
				// translators: %s will be replaced by donor email.
				confirmMessage = wp.i18n.sprintf(wp.i18n.__('Send email notification to %s?', 'levcharity'), donorEmail);
			}

			if ('hide-donor-name' === value && 'toggle_donation_visibility' === action) {
					proceed = true;
					params.append('action_name', value);
					params.append('status', 'on');
					// translators: %s will be replaced with the order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to hide donor\'s name for order ID %s. Are you sure?', 'levcharity'), id);
				}

				if ('show-donor-name' === value && 'toggle_donation_visibility' === action) {
					proceed = true;
					params.append('action_name', value);
					params.append('status', '');
					// translators: %s will be replaced with the order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to show donor\'s name for order ID %s. Are you sure?', 'levcharity'), id);
				}

				if ('hide-donation-amount' === value && 'toggle_donation_visibility' === action) {
					proceed = true;
					params.append('action_name', value);
					params.append('status', 'on');
					// translators: %s will be replaced with the order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to hide donor\'s amount for order ID %s. Are you sure?', 'levcharity'), id);
				}

				if ('show-donation-amount' === value && 'toggle_donation_visibility' === action) {
					proceed = true;
					params.append('action_name', value);
					params.append('status', '');
					// translators: %s will be replaced with the order id.
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to show donor\'s amount for order ID %s. Are you sure?', 'levcharity'), id);
				}

				if ('approve-campaign' === value) {
					proceed = true;
					params.append('status', 'publish');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to approve %s. Are you sure?', 'levcharity'), title);
				}

				if ('disapprove-campaign' === value) {
					proceed = true;
					params.append('status', 'pending');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to disapprove %s. Are you sure?', 'levcharity'), title);
				}

				if ('publish-ecard' === value || 'publish-membership' === value) {
					proceed = true;
					params.append('status', 'publish');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to publish %s. Are you sure?', 'levcharity'), title);
				}

				if ('draft-ecard' === value || 'draft-membership' === value) {
					proceed = true;
					params.append('status', 'draft');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of %s to draft. Are you sure?', 'levcharity'), title);
				}

				if ('activate-email' === value && 'change_email_status' === action) {
					proceed = true;
					params.append('status', '1');
				}

				if ('deactivate-email' === value && 'change_email_status' === action) {
					proceed = true;
					params.append('status', '0');
				}

				if ('activate-fund' === value && 'change_raisers_edge_funds_status' === action) {
					proceed = true;
					params.append( 'status', 'active' );
				}

				if ('deactivate-fund' === value && 'change_raisers_edge_funds_status' === action) {
					proceed = true;
					params.append( 'status', 'inactive' );
				}

				if ('activate-receipts' === value && 'change_receipts_status' === action) {
					proceed = true;
					params.append('status', '1');
				}

				if ('deactivate-receipts' === value && 'change_receipts_status' === action) {
					proceed = true;
					params.append('status', '0');
				}

				if ('activate-tribute-card' === value && 'change_tribute_card_status' === action) {
					proceed = true;
					params.append('status', '1');
				}

				if ('deactivate-tribute-card' === value && 'change_tribute_card_status' === action) {
					proceed = true;
					params.append('status', '0');
				}


				if ('delete-receipts' === value && 'delete_receipts' === action) {
					proceed = true;
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to delete receipt "%s". Are you sure?', 'levcharity'), title)
				}

				if ('delete-tribute-card' === value && 'delete_tribute_card' === action) {
					proceed = true;
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to delete tribute card "%s". Are you sure?', 'levcharity'), title)
				}

				if ('delete-email' === value && 'delete_levcharity_email' === action) {
					proceed = true;
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to delete email "%s". Are you sure?', 'levcharity'), title)
				}

				if ('activate-confirmation' === value && 'change_confirmation_status' === action) {
					proceed = true;
					params.append('status', '1');
				}

				if ('deactivate-confirmation' === value && 'change_confirmation_status' === action) {
					proceed = true;
					params.append('status', '0');
				}

				if ('delete-confirmation' === value && 'delete_levcharity_confirmation' === action) {
					proceed = true;
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to delete confirmation "%s". Are you sure?', 'levcharity'), title);
				}

				if ('approve-participant' === value || 'approve-member' === value) {
					proceed = true;
					params.append('status', 'publish');
					if (participantId) {
						params.append('participant_id', participantId);
					}
					if (teamId) {
						params.append('team_id', teamId);
					}
					if (campaignId) {
						params.append('campaign_id', campaignId);
					}
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of "%s" to approved. Are you sure?', 'levcharity'), title);
				}

				if ('cancel-participant' === value || 'cancel-member' === value) {
					proceed = true;
					params.append('status', 'cancelled');
					if (participantId) {
						params.append('participant_id', participantId);
					}
					if (teamId) {
						params.append('team_id', teamId);
					}
					if (campaignId) {
						params.append('campaign_id', campaignId);
					}
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of "%s" to disapproved. Are you sure?', 'levcharity'), title);
				}

				if ('approve-team-member' === value) {
					proceed = true;
					params.append('action_name', value);
					params.append('user_id', id);
					params.append('team_id', teamId);
					params.append('captain_id', captainId);
					params.append('status', 'approved');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of "%s" to approved. Are you sure?', 'levcharity'), title);
				}

				if ('cancel-team-member' === value) {
					proceed = true;
					params.append('action_name', value);
					params.append('user_id', id);
					params.append('team_id', teamId);
					params.append('captain_id', captainId);
					params.append('status', 'cancelled');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change status of "%s" to disapproved. Are you sure?', 'levcharity'), title);
				}

				if ('processing-warning' === value) {
					proceed = true;
					params.append('status', 'processing');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change warning status to processing for Salesforce ID %s. Are you sure?', 'levcharity'), title);
				}

				if ('complete-warning' === value) {
					proceed = true;
					params.append('status', 'completed');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change warning status to completed for Salesforce ID %s. Are you sure?', 'levcharity'), title);
				}

				if ('process-again' === value) {
					proceed = true;
					params.append('status', 'new');
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to change error status to new for ID %s. Are you sure?', 'levcharity'), title);
				}

				if ('duplicate' === value && 'levcharity_duplicate_record' === action) {
					proceed = true;
					params.append('duplicate', true);
					// translators: %s: post title
					confirmMessage = wp.i18n.sprintf(wp.i18n.__('You are about to duplicate. Are you sure?', 'levcharity'), title);
				}

				if (proceed === false) {
					return;
				}

				if (confirmation === true && confirmMessage) {
					const {Components} = await import('../helpers/Components.js' /* webpackChunkName: "components" */);

					const modal = Components.modals();
					modal.type('popup')
						.className('html-modal')
						.closeOnOutsideClick(false)
						.header(`<h1 class="levcharity_heading">${confirmMessage}</h1>`, true)
						.body(`
						 <div class="levcharity_popup_html delete_pop_up">
						   <button class="levcharity_button primary primary_button">${wp.i18n.__('Yes', 'levcharity')}</button>
						   <button class="levcharity_button levcharity_modal_close_button levcharity_popup_modal_close_button levcharity_modal_close_button_xmark levcharity_popup_modal_close_button_xmar">${wp.i18n.__('No', 'levcharity')}</button>
						 </div>
					   	`)
					modal.show();

					modal.setOnClose(() => {
						event.target.value = '';
					})

						if (!this.eventHandler) {
							this.eventHandler = {};
						}

						if (this.eventHandler['primary_button']) {
							document.querySelectorAll('.levcharity_popup_html .primary_button')?.forEach(button => {
								button.removeEventListener('click', this.eventHandler['primary_button']);
							});
						}

						this.eventHandler['primary_button'] = (eventsss) => {
							this.changeElementStatusAjax({ event, elementClass, value, params, id, action, url });
							modal.hide();
						};

						setTimeout(() => {
							document.querySelectorAll('.levcharity_popup_html .primary_button')?.forEach(button => {
								button.addEventListener('click', this.eventHandler['primary_button']);
							});
						}, 10);

				} else {
					this.changeElementStatusAjax({event, elementClass, value, params, id, action, url})
				}
			}
		});
	}

	async changeElementStatusAjax({event, elementClass, value, params, id, action, url}) {
		const {Components} = await import('../helpers/Components.js' /* webpackChunkName: "components" */);

		let modal = false;
		const queryString = params.toString();

		document.body.classList.add('has-overlay');
		const xhr = new XMLHttpRequest();
		xhr.open('POST', url, true);
		xhr.setRequestHeader(
			'Content-type',
			'application/x-www-form-urlencoded'
		);

		xhr.onreadystatechange = () => {
			let response = ''

			try {
				response = JSON.parse(xhr.response)
			} catch (e) {
				response = xhr.response;
			}
			if (
				xhr.readyState === XMLHttpRequest.DONE &&
				xhr.status === 400 &&
				value == 'cancel-participant'
			) {
				let message = JSON.parse(xhr.response).message;
				new Modals()
					.header(`<h1 class="levcharity_heading">${message}</h1>`)
					.body(`
					 <div class="levcharity_popup_html delete_pop_up">
					   <button class="levcharity_button levcharity_modal_close_button levcharity_popup_modal_close_button levcharity_modal_close_button_xmark levcharity_popup_modal_close_button_xmar">${wp.i18n.__('Ok', 'levcharity')}</button>
					 </div>
					`)
					.show()
				return
			}else {
			 	modal = Components.modals();
				modal.type('popup')
					.closeOnOutsideClick(false)
					.body(`
								 <div class="levcharity_popup_html delete_pop_up">
								   <button class="levcharity_button levcharity_modal_close_button levcharity_popup_modal_close_button levcharity_modal_close_button_xmark levcharity_popup_modal_close_button_xmar">Ok</button>
								 </div>
							   	`)
			}
			if (
				xhr.readyState === XMLHttpRequest.DONE &&
				xhr.status === 200
			) {
				const closestRow = event?.target?.closest('tr');
				let statusSpan = closestRow?.querySelector('.levcharity_datatable_action_status');
				if (!statusSpan && closestRow?.hasAttribute('data-dt-row')) {
					const parentRow = closestRow?.previousElementSibling;
					if (parentRow?.classList.contains('dt-hasChild')) {
						statusSpan = parentRow.querySelector('.levcharity_datatable_action_status');
					}
				}

				if (response?.message && modal) {
					modal.header(`<h1 class="levcharity_heading">${response.message}</h1>`).show();
				}

				const elementId = elementClass.replace(".", "#") + '_' + id;

				if ('complete-order' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('wc-processing', 'wc-pending', 'wc-completed');
						statusSpan.classList.add('wc-completed');
						statusSpan.innerText = wp.i18n.__('Completed', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="cancel-order"]`)?.removeAttribute('disabled');
				}

				if ('cancel-order' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('wc-processing', 'wc-pending', 'wc-completed');
						statusSpan.classList.add('wc-cancelled');
						statusSpan.innerText = wp.i18n.__('Cancelled', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="complete-order"]`)?.removeAttribute('disabled');
				}

				if ('approve-order' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('wc-awaiting-approval', 'wc-disapproved');
						statusSpan.classList.add('wc-pending');
						statusSpan.innerText = wp.i18n.__('Pending', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="approve-order"]`)?.setAttribute('disabled', 'disabled');
				}

				if ('disapprove-order' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('wc-awaiting-approval', 'wc-pending');
						statusSpan.classList.add('wc-disapproved');
						statusSpan.innerText = wp.i18n.__('Disapproved', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="disapprove-order"]`)?.setAttribute('disabled', 'disabled');
				}

				if ('activate-subscription' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('wc-on-hold', 'wc-cancelled');
						statusSpan.classList.add('wc-active');
						statusSpan.innerText = wp.i18n.__('Active', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="pause-subscription"]`)?.removeAttribute('disabled');
					document.querySelector(`${elementId} option[value="cancel-subscription"]`)?.removeAttribute('disabled');
				}

				if ('pause-subscription' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('wc-active', 'wc-cancelled');
						statusSpan.classList.add('wc-on-hold');
						statusSpan.innerText = wp.i18n.__('On Hold', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="activate-subscription"]`)?.removeAttribute('disabled');
					document.querySelector(`${elementId} option[value="cancel-subscription"]`)?.removeAttribute('disabled');
				}

				if ('cancel-subscription' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('wc-active', 'wc-on-hold');
						statusSpan.classList.add('wc-cancelled');
						statusSpan.innerText = wp.i18n.__('Cancelled', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="activate-subscription"]`)?.removeAttribute('disabled');
					document.querySelector(`${elementId} option[value="pause-subscription"]`)?.removeAttribute('disabled');
				}

				if ('hide-donor-name' === value) {
					document.querySelector(`${elementId} option[value="show-donor-name"]`)?.removeAttribute('disabled');
				}

				if ('show-donor-name' === value) {
					document.querySelector(`${elementId} option[value="hide-donor-name"]`)?.removeAttribute('disabled');
				}

				if ('hide-donation-amount' === value) {
					document.querySelector(`${elementId} option[value="show-donation-amount"]`)?.removeAttribute('disabled');
				}

			if ('show-donation-amount' === value) {
				document.querySelector(`${elementId} option[value="hide-donation-amount"]`)?.removeAttribute('disabled');
			}

			if ('generate-receipt' === value) {
				// Receipt generation completed successfully
				if (modal && response?.message) {
					modal.header(`<h1 class="levcharity_heading">${response.message}</h1>`);
				}
			}

			if ('send-email' === value) {
				// Email sent successfully
				if (modal && response?.message) {
					modal.header(`<h1 class="levcharity_heading">${response.message}</h1>`);
				}
			}

			if ('approve-campaign' === value) {
					if (statusSpan) {
						if(statusSpan.classList.contains('reviewed')){
							statusSpan.classList.remove('reviewed');
						}
						statusSpan.classList.remove('pending');
						statusSpan.classList.add('publish');
						statusSpan.innerText = wp.i18n.__('Publish', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="disapprove-campaign"]`)?.removeAttribute('disabled');
				}

				if ('disapprove-campaign' === value) {
					if (statusSpan) {
						if(statusSpan.classList.contains('reviewed')){
							statusSpan.classList.remove('reviewed');
						}
						statusSpan.classList.remove('publish');
						statusSpan.classList.add('pending');
						statusSpan.innerText = wp.i18n.__('Pending', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="approve-campaign"]`)?.removeAttribute('disabled');
				}

				if ('publish-ecard' === value || 'publish-membership' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('draft');
						statusSpan.classList.add('publish');
						statusSpan.innerText = wp.i18n.__('Publish', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="draft-ecard"]`)?.removeAttribute('disabled');
				}

				if ('draft-ecard' === value || 'draft-membership' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('publish');
						statusSpan.classList.add('draft');
						statusSpan.innerText = wp.i18n.__('Draft', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="publish-ecard"]`)?.removeAttribute('disabled');
				}

				if ('activate-email' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('status-inactive');
						statusSpan.classList.add('status-active');
						statusSpan.innerText = wp.i18n.__('Active', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="deactivate-email"]`)?.removeAttribute('disabled');
				}

				if ('deactivate-email' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('status-active');
						statusSpan.classList.add('status-inactive');
						statusSpan.innerText = wp.i18n.__('Inactive', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="activate-email"]`)?.removeAttribute('disabled');
				}

				if('activate-receipts' === value){
					if (statusSpan) {
						statusSpan.classList.remove('status-inactive');
						statusSpan.classList.add('status-active');
						statusSpan.innerText = wp.i18n.__('Active', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="deactivate-receipts"]`)?.removeAttribute('disabled');
				}

				if('deactivate-receipts' === value){
					if (statusSpan) {
						statusSpan.classList.remove('status-active');
						statusSpan.classList.add('status-inactive');
						statusSpan.innerText = wp.i18n.__('Inactive', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="activate-receipts"]`)?.removeAttribute('disabled');
				}


				if('activate-tribute-card' === value){
					if (statusSpan) {
						statusSpan.classList.remove('status-inactive');
						statusSpan.classList.add('status-active');
						statusSpan.innerText = wp.i18n.__('Active', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="deactivate-tribute-card"]`)?.removeAttribute('disabled');
				}

				if('deactivate-tribute-card' === value){
					if (statusSpan) {
						statusSpan.classList.remove('status-active');
						statusSpan.classList.add('status-inactive');
						statusSpan.innerText = wp.i18n.__('Inactive', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="activate-tribute-card"]`)?.removeAttribute('disabled');
				}

				if ('delete-receipts' === value && 'delete_receipts' === action) {
					closestRow?.remove();
				}
				if ('delete-tribute-card' === value && 'delete_tribute_card' === action) {
					closestRow?.remove();
				}

				if ('delete-email' === value || 'delete-confirmation' === value) {
					closestRow?.remove();
				}

				if ('activate-confirmation' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('status-inactive');
						statusSpan.classList.add('status-active');
						statusSpan.innerText = wp.i18n.__('Active', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="deactivate-confirmation"]`)?.removeAttribute('disabled');
				}

				if ('deactivate-confirmation' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('status-active');
						statusSpan.classList.add('status-inactive');
						statusSpan.innerText = wp.i18n.__('Inactive', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="activate-confirmation"]`)?.removeAttribute('disabled');
				}

				if ('approve-participant' === value || 'approve-member' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('pending', 'disapproved');
						statusSpan.classList.add('publish');
						statusSpan.innerText = wp.i18n.__('Published', 'levcharity');
					}
				}

				if ('approve-participant' === value) {
					const cancelParticipantOpt = document.querySelector(`${elementId} option[value="cancel-participant"]`);
					if (cancelParticipantOpt && cancelParticipantOpt.getAttribute('data-is-captain') !== '1') {
						cancelParticipantOpt.removeAttribute('disabled');
					}
					setTimeout(()=>{
						const cancelDiv = document.querySelector(`div[data-value="cancel-participant"][data-id="${id}"]`);
						if (cancelDiv && cancelDiv.getAttribute('data-is-captain') !== '1') {
							cancelDiv.removeAttribute('disabled');
						}
						document.querySelector(`div[data-value="approve-participant"][data-id="${id}"]`)?.setAttribute('disabled', 'true');
					}, 200)
				}

				if(('approve-participant' === value || 'cancel-participant' == value) && action == 'change_team_member_and_participant_campaign_status'){
					if(this.#fundraiserDatatable){
						this.#fundraiserDatatable?.ajax?.reload();
					}
				}


				if ('approve-member' === value) {
					const cancelMemberOpt = document.querySelector(`${elementId} option[value="cancel-member"]`);
					if (cancelMemberOpt && cancelMemberOpt.getAttribute('data-is-captain') !== '1') {
						cancelMemberOpt.removeAttribute('disabled');
					}
				}

				if ('cancel-participant' === value || 'cancel-member' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('pending', 'publish');
						statusSpan.classList.add('disapproved');
						statusSpan.innerText = wp.i18n.__('Disapproved', 'levcharity');
					}
				}

				if ('cancel-participant' === value) {
					document.querySelector(`${elementId} option[value="approve-participant"]`)?.removeAttribute('disabled');
					setTimeout(()=>{
						document.querySelector(`div[data-value="approve-participant"][data-id="${id}"]`)?.removeAttribute('disabled');
						document.querySelector(`div[data-value="cancel-participant"][data-id="${id}"]`)?.setAttribute('disabled', 'true');
					}, 200)
				}

				if ('cancel-member' === value) {
					document.querySelector(`${elementId} option[value="approve-member"]`)?.removeAttribute('disabled');
				}

				if ('approve-team-member' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('pending', 'disapproved');
						statusSpan.classList.add('approved');
						statusSpan.innerText = wp.i18n.__('Approved', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="cancel-team-member"]`)?.removeAttribute('disabled');
				}

				if ('cancel-team-member' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('pending', 'approved');
						statusSpan.classList.add('disapproved');
						statusSpan.innerText = wp.i18n.__('Disapproved', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="approve-team-member"]`)?.removeAttribute('disabled');
				}

				if ('processing-warning' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('new', 'completed');
						statusSpan.classList.add('processing');
						statusSpan.innerText = wp.i18n.__('Processing', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="complete-warning"]`)?.removeAttribute('disabled');
				}

				if ('complete-warning' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('new', 'processing');
						statusSpan.classList.add('completed');
						statusSpan.innerText = wp.i18n.__('Completed', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="processing"]`)?.removeAttribute('disabled');
				}

				if ('process-again' === value) {
					if (statusSpan) {
						statusSpan.classList.remove('error');
						statusSpan.classList.add('new');
						statusSpan.innerText = wp.i18n.__('New', 'levcharity');
					}
					document.querySelector(`${elementId} option[value="process-again"]`)?.removeAttribute('disabled');
				}

				event.target.selectedOptions[0].setAttribute('disabled', 'disabled');
				event.target.value = '';

				const actionDropdown = event.target.closest('.dt_actions_wrapper').querySelector('.actions-dropdown');

				[...event.target.options].forEach(option => {
					actionDropdown.querySelectorAll(`[data-value="${option.value}"]`)
						.forEach(dropdownOption => {
							if(option.disabled) {
								dropdownOption.setAttribute('disabled', 'disabled');
							} else {
								dropdownOption.removeAttribute('disabled');
							}
						})
				})

				const flushRedisButton = DOM.el('.flush-redis-button');
				if (this.#isSalesforceLogStatusAction(action)) {
					this.#reloadSalesforceLogTable(action);
				} else if(flushRedisButton &&  action !== 'change_team_member_and_participant_campaign_status' ) {
					flushRedisButton.click();
				}

				if (response?.reload) {
					window.location.reload();
				}

			} else if ( xhr.readyState === XMLHttpRequest.DONE ) {
				let response = ''

				try {
					response = JSON.parse(xhr.response)
				} catch (e) {
					response = xhr.response;
				}

				if (response?.message) {
					modal.header(`<h1 class="levcharity_heading">${response.message}</h1>`).show()
				} else {
					modal.header(`<h1 class="levcharity_heading">${message}</h1>`).show()
				}
			}
			document.body.classList.remove('has-overlay');
		};

		xhr.send(queryString);

	}

	triggerAction(elementClass, action, type = 'change') {
		document.addEventListener(type, async ( event ) => {
			if ( event.target.matches(elementClass)) {
				const value = event.target.value;
				const token = event.target.selectedOptions[0].dataset.token;
				const id = event.target.selectedOptions[0].dataset.id;

				if (action === 'open_commitments_modal' && value === 'commitments-modal') {
					const {Components} = await import('./Components.js' /* webpackChunkName: "components" */);

					const contentHTML = `<div class="levcharity_commitments_popup_body"></div>`;

					Components.modals()
						.type('popup')
						.className('levcharity_commitments')
						.header('Commitments')
						.body(contentHTML)
						.closeOnOutsideClick(false)
						.footer(`<button class="levcharity_button small primary_button confirm_commitment_button" data-token="${token}" data-id="${id}">${wp.i18n.__('Confirm', 'levcharity')}</button>`)
						.show();

					setTimeout(() => {
						DOM.triggerEvent(
							DOM.el('.levcharity_commitments .confirm_commitment_button'),
							'levcharity_commitment_modal_open'
						)
					}, 0)

					event.target.value = '';
				} else if (action === 'archive_team_campaign' && value === 'archive-campaign') {
					const {Components} = await import('./Components.js' /* webpackChunkName: "components" */);

					const contentHTML = `<h2 class="levcharity_heading">${wp.i18n.__('Are you sure?', 'levcharity')}</h2><p class="levcharity_paragraph">${wp.i18n.__(`You are about archiving the data for team campaign (${id}), archived data cannot be reverted back.`, 'levcharity')}</p>`;

					Components.modals()
						.type('popup')
						.className('levcharity_archive_teams')
						.header(contentHTML)
						.closeOnOutsideClick(false)
						.footer(`<button class="levcharity_button small primary_button" data-token="${token}" data-id="${id}">${wp.i18n.__('Confirm', 'levcharity')}</button>`)
						.show();

				}
			}
		});
	}
}
